import keyMirror from 'keymirror';

import { FRONTEND_ROUTES } from '@/services/Constants';
import { renderFormulas } from '@/services/FormulaUtils';

import type { QuestionType } from '@/pages/report/types';

export const reportActionTypes = keyMirror({
	GET_PLAYLIST_SECTION_REPORT_REQUEST: null,
	GET_PLAYLIST_SECTION_REPORT_SUCCESS: null,
	GET_PLAYLIST_SECTION_REPORT_ERROR: null,

	CLEAR_STATE: null,
});

export const questionTypeIconCodes: Record<QuestionType, string> = {
	'Question::OpenEnded': 'icon-writing',
	'Question::Dictation': 'icon-hearing',
	'Question::InYourMind': 'icon-cloud',
	'Question::MultipleChoiceSingleAnswer': 'icon-list-bulleted',
	'Question::FillInTheBlanks': 'icon-paint-pour',
	'Question::OpenQuestionMultipleAnswers': 'icon-writing',
	'Question::DictationMultipleChoice': 'icon-hearing-multiple',
	'Question::MultipleChoiceMultipleAnswers': 'icon-list-bulleted',
	'Question::TellTime::DigitalToAnalog': 'icon-clock',
	'Question::TellTime::AnalogToDigital': 'icon-clock',
	'Question::TellTime::TextToDigital': 'icon-clock',
	'Question::TellTime::TextToAnalog': 'icon-clock',
};

export const questionTypeNameCodes: Record<QuestionType, string> = {
	'Question::OpenEnded': 'open',
	'Question::Dictation': 'dictation',
	'Question::InYourMind': 'in_your_mind',
	'Question::MultipleChoiceSingleAnswer': 'multiple_choice',
	'Question::FillInTheBlanks': 'fill_in_the_blanks',
	'Question::OpenQuestionMultipleAnswers': 'open',
	'Question::DictationMultipleChoice': 'dictation_multiple',
	'Question::MultipleChoiceMultipleAnswers': 'multiple_choice',
	'Question::TellTime::DigitalToAnalog': 'analog_clock',
	'Question::TellTime::AnalogToDigital': 'digital_clock',
	'Question::TellTime::TextToDigital': 'digital_clock',
	'Question::TellTime::TextToAnalog': 'analog_clock',
};

export const getReportQuestionPath = (sectionId: string, questionId: string): string => {
	return FRONTEND_ROUTES.EXERCISE_REPORT.replace(':id', sectionId).replace(
		':questionId',
		questionId,
	);
};

export const getReplayQuestionPath = (sectionId: string, questionId: string): string => {
	return FRONTEND_ROUTES.EXERCISE_REPLAY.replace(':id', sectionId).replace(
		':questionId',
		questionId,
	);
};

export const getReportSectionPath = (sectionId: string): string => {
	return FRONTEND_ROUTES.REPORT.replace(':id', sectionId);
};

export const getQuestionTitle = (
	title: string | undefined,
	question_display: string | string[],
): string => {
	const body = Array.isArray(question_display) ? question_display[0] : question_display;
	const sanitizedQuestion = body.replace(/<[^>]*>/g, '');
	const firstSentence = sanitizedQuestion.split('.')[0].trim();
	const content = title || (firstSentence ? firstSentence : sanitizedQuestion) || '';
	return renderFormulas(content, false);
};
